import React, { useState } from "react";
import { Link } from "react-router-dom";
import './newHeader.css';
import logo from '../../assets/images/logo-new-yellow-no-text.png';

const NewHeader = ({ metroArea, serviceProvider = {} }) => {
  const [showAlert, setShowAlert] = useState(false);

  const showMessageAlert = () => {
    setShowAlert(!showAlert);
  };

  const navigateToPage = (route) => {
    setShowAlert(false);
    window.location.replace(`https://www.propagile.com/building-construction-teams/${route}`);
  };

  return (
    <>
      {showAlert && (
        <div className="modal is-active custom-modal error-message">
          <div className="modal-background" onClick={showMessageAlert}></div>
          <div className="modal-content">
            <div className="error-message-modal new-header-modal-inner">
              <button onClick={showMessageAlert} className="modal-close"></button>
              <p className="modal-title-text">I am a:</p>
              <div className="modal-buttons">
                <button onClick={() => navigateToPage('builders')} className="btn-fill-menu">
                  Builder
                </button>
                <button onClick={() => navigateToPage('customers')} className="btn-fill-menu">
                  Customer
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <header className="site-header new-header-container" id="siteHeader">
        <section className="land-main-menu">
          <div className="container">
            <nav className="navbar new-header-navbar">
              <div className="d-flex flex-row align-items-center brand-container">
                <span>
                  <img
                    alt="propagile"
                    className="img-fluid d-block mr-4 brand-logo"
                    src={logo}
                    width={60}
                  />
                </span>
                <Link to="/" className="navbar-brand new-header-brand">
                  <div className="brand-text-wrapper">
                    <span className="brand-title">Construction Brain</span>
                    <span className="brand-subtitle">Construction Experts in Your Pocket</span>
                  </div>
                </Link>
              </div>

              <div className="navbar-actions">
                {!serviceProvider?.id ? (
                  <div className="auth-buttons">
                    <Link to="/sign-up" className="btn-nav-outline">
                      Sign Up
                    </Link>
                    <Link
                      to="/login"
                      className="btn-nav-solid"
                    >
                      Sign In
                    </Link>
                  </div>
                ) : (
                  <div className="auth-buttons">
                    <Link to="/dashboard" className="btn-nav-solid">
                      Dashboard
                    </Link>
                  </div>
                )}
              </div>
            </nav>
          </div>
        </section>
      </header>
    </>
  );
};

export default NewHeader;